const templateUrl = require('./views/change-shipment-date-button.html');

module.exports = {
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'ChangeShipmentDateController',
  templateUrl: templateUrl
};
